window.getSelectDepartment = (data: any) => { // 接受原生的回调
  const userList = JSON.parse(data) || []
  const event = new CustomEvent('userEvent', {detail: userList});
  window.dispatchEvent(event);
}
